(function () {
    'use strict';

    var version_number = '1.0.000';

    const api_base_url = '/'; // ends with a /

    function routeConditions(config) {
        if(config.url.indexOf('.html') !== -1) {
            return false;
        }
        if(config.url.indexOf('.json') !== -1) {
            return false;
        }
        if(config.url.indexOf('system_texts.php') !== -1) {
            return false;
        }
        return true;
    }

    angular
        .module('app')
        .config(function ($provide) {
            // Extends the state object to know the next state in the transitions between states
            $provide.decorator('$state', function ($delegate, $rootScope) {
                $rootScope.$on('$stateChangeStart', function (event, state) {
                    $delegate.next = state;
                });
                return $delegate;
            });
        })
        .config(function ($httpProvider) {
            $httpProvider.useApplyAsync(true)
            $httpProvider.interceptors.push(function ($q) {
                return {
                    'request': function (config) {
                        if (routeConditions(config)) {
                            var urlWithoutSlash = (config.url[0] === '/' ? config.url.substring(1) : config.url);
                            urlWithoutSlash = urlWithoutSlash[urlWithoutSlash.length-1] === '/' ? urlWithoutSlash.substring(0,urlWithoutSlash.length-1) : urlWithoutSlash;
                            config.url = api_base_url + urlWithoutSlash.replace('app/', '')
                        }
                        return config || $q.when(config);
                    }
                }
            });
        })
        .run(function ($transitions, $rootScope, $document, $timeout, $state) {
            $transitions.onStart({}, function () {
                $rootScope.router_loading = true;
            });

            $transitions.onFinish({}, function () {
                $rootScope.router_loading = false;
                $document[0].body.scrollTop = $document[0].documentElement.scrollTop = 0;
                $timeout(function () {
                    var states = ['login', 'login_return', 'sign_up', 'forgotten_password', 'sign_up_start', 'forgotten_password', 'reset_password'];
                    $rootScope.change_header = false;
                    var current = states.find(function (s) {
                        return s == $state.current.name;
                    });
                    if (current != null) {
                        $rootScope.change_header = true;
                    }
                }, 0);
            });
        })
        .run(function ($cookies, $rootScope, $timeout, $state, $location, $window, localization) {
            var urlLang = "";
            /* $timeout(function () {
                var cookieLanguage = $cookies.get('selected_language');
                urlLang = $state.toParams.language;
                if (urlLang && cookieLanguage.indexOf(urlLang) < 0) {
                    if (urlLang == 'da') {
                        localization.setLanguage('da_dk');
                    } else if (urlLang == 'sv') {
                        localization.setLanguage('sv');
                    }
                    else {
                        localization.setLanguage('en_us');
                    }
                }
            }, 500); */

            let language = "";

            if ($cookies.get('selected_language') == undefined) {
                if (window.navigator.language == 'da' || window.navigator.language == 'da_dk') {
                    language = "da";
                    localization.setLanguage('da_dk');
                } else if (window.navigator.language == 'sv' || window.navigator.language == 'se_sv') {
                    language = "sv";
                    localization.setLanguage('sv');
                } else {
                    language = "en";
                    localization.setLanguage('en_us');
                }
            } else {
                if ($cookies.get('selected_language') == "en_us") {
                    language = "en";
                    localization.setLanguage('en_us');
                } else if ($cookies.get('selected_language') == "sv") {
                    language = "sv";
                    localization.setLanguage('sv');
                } else {
                    language = "da";
                    localization.setLanguage('da_dk');
                }
            }

            if ($location.path() == '/' + language + '/concerts' || $location.path() == '/concerts') {
                $window.location.href = '/' + language + '/concerts/';
            }

            /* if ($location.path() == '/' + language + '/member' || $location.path() == '/member/') {
                $window.location.href = '/' + language + '/member/';
            } */

            $rootScope.$on('$locationChangeStart', function (event, current, previous) {
                $rootScope.previousURL = previous;
            });

        })
        .config(function ($stateProvider, $urlRouterProvider, $urlMatcherFactoryProvider, $locationProvider) {
            $urlMatcherFactoryProvider.strictMode(false);

            var match = decodeURIComponent(document.cookie).split('; ');
            var regex_test = /selected_language=/;
            var language_from_cookie = 'en';
            var language_from_cookie_front_page = '';
            for (var i = 0; i < match.length; i++) {
                if (regex_test.test(match[i])) {
                    switch (match[i].replace('selected_language=', '')) {
                        case 'en_us':
                        case 'en_uk':
                            language_from_cookie = 'en';
                            language_from_cookie_front_page = '';
                            break;
                        case 'da_dk':
                            language_from_cookie = 'da';
                            language_from_cookie_front_page = 'da';
                            break;
                        case 'sv':
                            language_from_cookie = 'sv';
                            language_from_cookie_front_page = 'sv';
                            break;
                    }
                }
            }

            var regex_test = /selected_location=/;
            var selected_location = '';
            for (var i = 0; i < match.length; i++) {
                if (regex_test.test(match[i])) {
                    switch (match[i].replace('selected_location=', '')) {
                        case 'denmark':
                            selected_location = 'denmark';
                            break;
                        case 'sweden':
                            selected_location = 'sweden';
                            break;
                    }
                }
            }

            // For any unmatched url, redirect to state "frontpage"
            // todo determine correct use - also for assets
            // $urlRouterProvider.otherwise(function ($injector) {
            //     var $state = $injector.get('$state');
            //     $state.go('item_deleted');
            // });

            $locationProvider.hashPrefix('!');
            $locationProvider.html5Mode(true);

            // States for the view
            $stateProvider
                .state('frontpage', {
                    url: '/:language?/:location?',
                    templateUrl: 'pages/frontpage/view.frontpage.html',
                    controller: 'FrontpageController',
                    controllerAs: 'vm',
                    params: {language: language_from_cookie_front_page, location: selected_location},
                    reloadOnSearch: false
                })
                .state('member', {
                    url: '/:language/member/:tab?',
                    templateUrl: 'pages/member/view.member.html',
                    controller: 'MemberController',
                    controllerAs: 'vm',
                    params: {
                        language: language_from_cookie,
                        tab: {
                            value: "concerts",
                            dynamic: true
                        }
                    },
                    resolve: {
                        authResolve: authResolve
                    },
                    reloadOnSearch: false
                })
                .state('settings', {
                    url: '/:language/member/settings',
                    templateUrl: 'pages/settings/view.settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm',
                    params: {language: language_from_cookie},
                    resolve: {
                        authResolve: authResolve,
                        countries: function ($http) {
                            return $http.get('/pages/sign_up/countries-' + language_from_cookie + '.json')
                                .then(function (response) {
                                    return response.data;
                                });
                        }
                    },
                    reloadOnSearch: false
                })
                .state('tickets', {
                    url: '/:language/member/tickets/:tab?',
                    templateUrl: 'pages/tickets/view.tickets.html',
                    controller: 'TicketsController',
                    controllerAs: 'vm',
                    params: {language: language_from_cookie, tab: {value: "upcoming", dynamic: true}},
                    resolve: {
                        authResolve: authResolve
                    },
                    reloadOnSearch: false
                })

                .state('ticket_price_estimator', {
                    url: '/:language/ticket_price_estimator/:main_genre?',
                    templateUrl: 'pages/ticket_price_estimator/view.ticket_price_estimator.html',
                    controller: 'TicketPriceEstimatorController',
                    controllerAs: 'vm',
                    params: {language: language_from_cookie, main_genre: null},
                    reloadOnSearch: false
                })

                .state('saved', {
                    url: '/:language/member/saved/:tab?',
                    templateUrl: 'pages/saved/view.saved.html',
                    controller: 'SavedController',
                    controllerAs: 'vm',
                    params: {language: language_from_cookie, tab: {value: "musicians", dynamic: true}},
                    resolve: {
                        authResolve: authResolve
                    },
                    reloadOnSearch: false
                })
                .state('following', {
                    url: '/:language/member/following/:tab?',
                    templateUrl: 'pages/following/view.following.html',
                    controller: 'FollowingController',
                    controllerAs: 'vm',
                    params: {language: language_from_cookie, tab: {value: "all", dynamic: true}},
                    resolve: {
                        authResolve: authResolve
                    },
                    reloadOnSearch: false
                })
                .state('my_concerts', {
                    url: '/:language/member/my_concerts/:tab?',
                    templateUrl: 'pages/my_concerts/view.my_concerts.html',
                    controller: 'MyConcertsController',
                    controllerAs: 'vm',
                    params: {language: language_from_cookie, tab: {value: "upcoming", dynamic: true}},
                    resolve: {
                        authResolve: authResolve
                    },
                    reloadOnSearch: false
                })
                .state('member_public', {
                    url: '/:language/user/:user_slug',
                    templateUrl: 'pages/member_public/view.member_public.html',
                    controller: 'MemberPublicController',
                    controllerAs: 'vm',
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('just_signed_up', {
                    url: '/:language/signed_up',
                    templateUrl: 'pages/member/view.member.html',
                    controller: 'MemberController',
                    controllerAs: 'vm',
                    params: {language: language_from_cookie_front_page},
                    reloadOnSearch: false
                })
                .state('sign_up', {
                    url: '/:language/sign_up/?concert&no_of_tickets',
                    templateUrl: 'pages/sign_up/view.sign_up.html',
                    controller: 'SignUpController',
                    controllerAs: 'vm',
                    params: {
                        'user_email': '',
                        language: language_from_cookie,
                        user_info: '',
                        get_data: false,
                        'backToStateName': '',
                        'backToStateParams': {}
                    },
                    resolve: {
                        countries: function ($http) {
                            return $http.get('/pages/sign_up/countries-' + language_from_cookie + '.json')
                                .then(function (response) {
                                    return response.data;
                                });
                        }
                    },
                    reloadOnSearch: false
                })
                .state('sign_up_start', {
                    url: '/:language/sign_up_start?concert&no_of_tickets',
                    templateUrl: 'pages/login/view.login.html',
                    controller: 'LoginController',
                    controllerAs: 'vm',
                    params: {
                        'backToStateName': '',
                        'backToStateParams': {},
                        'language': language_from_cookie
                    },
                    reloadOnSearch: false
                })
                .state('login', {
                    url: '/:language/login?concert&no_of_tickets',
                    templateUrl: 'pages/login/view.login.html',
                    controller: 'LoginController',
                    controllerAs: 'vm',
                    params: {
                        'backToStateName': '',
                        'backToStateParams': {},
                        'language': language_from_cookie,
                        'source_page': null
                    },
                    reloadOnSearch: false
                })
                .state('login_return', {
                    url: '/:language/login_return?concert&no_of_tickets',
                    templateUrl: 'pages/login_return/view.login_return.html',
                    controller: 'LoginReturnController',
                    controllerAs: 'vm',
                    params: {
                        'user_email': '',
                        'backToStateName': '',
                        'backToStateParams': {},
                        'language': language_from_cookie,
                        'source_page': null
                    },
                    reloadOnSearch: false
                })
                .state('concert', {
                    url: '/:language/concert/:concert_slug',
                    templateUrl: 'pages/concert/view.concert.html',
                    controller: 'ConcertController',
                    controllerAs: 'vm',
                    params: {language: language_from_cookie, source_page: null},
                    reloadOnSearch: false
                })
                .state('host', {
                    url: '/:language/host/:space_slug',
                    templateUrl: 'pages/host/view.host.html',
                    controller: 'HostController',
                    controllerAs: 'vm',
                    params: {language: language_from_cookie, favorite: false},
                    reloadOnSearch: false
                })
                .state('musician', {
                    url: '/:language/musician/:band_slug',
                    templateUrl: 'pages/musician/view.musician.html',
                    controller: 'MusicianController',
                    controllerAs: 'vm',
                    params: {language: language_from_cookie, favorite: false},
                    reloadOnSearch: false
                })
                .state('concerts', {
                    url: '/:language/concerts/:page?/:location?/:adminFilter?/:genre?/:sort?/:date_filter?/:date_start?/:date_end?/:search?/:country_filter?/:tag?',
                    templateUrl: 'pages/concerts/view.concerts.html',
                    controller: 'ConcertsController',
                    controllerAs: 'vm',
                    params: {
                        language: language_from_cookie,
                        page: {value: "1", dynamic: true},
                        location: {value: 'all', dynamic: true},
                        adminFilter: {value: 'all', dynamic: true},
                        genre: {value: 'any', dynamic: true},
                        tag: {value: 'any', dynamic: true},
                        sort: {value: 'concert_date', dynamic: true},
                        search: {value: '', dynamic: true},
                        date_filter: {value: 'any', dynamic: true},
                        date_start: {value: "", dynamic: true},
                        date_end: {value: "", dynamic: true},
                        country_filter: {value: '', dynamic: true}
                    },
                    reloadOnSearch: false
                })
                .state('musicians', {
                    url: '/:language/musicians/:page?/:genre?/:sort?/:search?/:private?/:booking_levels?/:location_filter?/:location?/:status?',
                    templateUrl: 'pages/musicians/view.musicians.html',
                    controller: 'MusiciansController',
                    controllerAs: 'vm',
                    params: {
                        language: language_from_cookie,
                        page: {value: "1", dynamic: true},
                        genre: {value: 'any', dynamic: true},
                        sort: {value: 'relevance', dynamic: true},
                        search: {value: '', dynamic: true},
                        private: {value: '', dynamic: true},
                        booking_levels: {value: '', dynamic: true},
                        location_filter: {value: 'all', dynamic: true},
                        location: {value: 'any', dynamic: true},
                        status: {value: 'all', dynamic: true}
                    },
                    reloadOnSearch: false
                })
                .state('hosts', {
                    url: '/:language/hosts/:page?/:location?/:spaceType?/:status?/:seatRange?/:sortingOrder?/:search?/:country_filter?',
                    templateUrl: 'pages/hosts/view.hosts.html',
                    controller: 'HostsController',
                    controllerAs: 'vm',
                    params: {
                        language: language_from_cookie,
                        page: {value: "1", dynamic: true},
                        location: {value: 'all', dynamic: true},
                        spaceType: {value: 'all', dynamic: true},
                        status: {value: 'all', dynamic: true},
                        seatRange: {value: 'all', dynamic: true},
                        sortingOrder: {value: 'relevance', dynamic: true},
                        search: {value: '', dynamic: true},
                        country_filter: {value: '', dynamic: true}
                    },
                    reloadOnSearch: false
                })
                .state('messages', {
                    url: '/:language/messages',
                    templateUrl: 'pages/messages/view.messages.html',
                    controller: 'MessagesController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve
                    },
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('cookie_policy', {
                    url: '/:language/cookies/policy',
                    templateUrl: 'pages/html/view.html.html',
                    params: {language: language_from_cookie},
                })
                .state('create_concert', {
                    url: '/:language/create/concert/:band_slug/:space_slug',
                    templateUrl: 'pages/create_edit_concert/view.create_edit_concert.html',
                    controller: 'CreateEditConcertController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve,
                        countries: function ($http) {
                            return $http.get('/pages/sign_up/countries-' + language_from_cookie + '.json')
                                .then(function (response) {
                                    return response.data;
                                });
                        }
                    },
                    params: {language: language_from_cookie, band_slug: null, space_slug: null},
                    reloadOnSearch: false
                })
                .state('edit_concert', {
                    url: '/:language/edit/concert/:concert_slug',
                    templateUrl: 'pages/create_edit_concert/view.create_edit_concert.html',
                    controller: 'CreateEditConcertController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve,
                        countries: function ($http) {
                            return $http.get('/pages/sign_up/countries-' + language_from_cookie + '.json')
                                .then(function (response) {
                                    return response.data;
                                });
                        }
                    },
                    params: {language: language_from_cookie, back_from_preview_or_save: null},
                    reloadOnSearch: false
                })
                .state('reschedule_concert', {
                    url: '/:language/reschedule_concert/:concert_slug',
                    templateUrl: 'pages/reschedule_concert/view.reschedule_concert.html',
                    controller: 'RescheduleConcertController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve
                    },
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('checkout', {
                    url: '/:language/checkout/:checkout_id',
                    templateUrl: 'pages/checkout/view.checkout.html',
                    controller: 'CheckoutController',
                    controllerAs: 'vm',
                    resolve: {
                        /*  authResolve: authResolve, */
                        countries: function ($http) {
                            return $http.get('/pages/sign_up/countries-' + language_from_cookie + '.json')
                                .then(function (response) {
                                    return response.data;
                                });
                        }
                    },
                    params: {language: language_from_cookie, checkout_id: null, concert: null, ticket_amount: null, additional_purchase_amount: null},
                    reloadOnSearch: false
                })
                .state('buy_tickets', {
                    url: '/:language/buy_tickets/:concert_slug',
                    templateUrl: 'pages/buy_tickets/view.buy_tickets.html',
                    controller: 'BuyTicketsController',
                    controllerAs: 'vm',
                    params: {language: language_from_cookie, source_page: null},
                    reloadOnSearch: false
                })
                .state('ticket_checkout_complete', {
                    url: '/:language/ticket_checkout_complete/:checkout_id',
                    templateUrl: 'pages/ticket_checkout_complete/view.ticket_checkout_complete.html',
                    controller: 'TicketCheckoutCompleteController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve
                    },
                    params: {language: language_from_cookie, checkout_id: null, concert: null, ticket_amount: null},
                    reloadOnSearch: false
                })
                .state('booking_checkout_complete', {
                    url: '/:language/booking_checkout_complete/:checkout_id',
                    templateUrl: 'pages/booking_checkout_complete/view.booking_checkout_complete.html',
                    controller: 'BookingCheckoutCompleteController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve
                    },
                    params: {language: language_from_cookie, checkout_id: null},
                    reloadOnSearch: false
                })
                .state('gift_card_guide', {
                    url: '/:language/gift_card_guide',
                    templateUrl: 'pages/gift_card_guide/view.gift_card_guide.html',
                    controller: 'GiftCardGuideController',
                    controllerAs: 'vm',
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('buy_gift_card', {
                    url: '/:language/buy_gift_card',
                    templateUrl: 'pages/buy_gift_card/view.buy_gift_card.html',
                    controller: 'BuyGiftCardController',
                    controllerAs: 'vm',
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('gift_card_checkout_complete', {
                    url: '/:language/gift_card_checkout_complete',
                    templateUrl: 'pages/gift_card_checkout_complete/view.gift_card_checkout_complete.html',
                    controller: 'GiftCardCheckoutCompleteController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve
                    },
                    params: {language: language_from_cookie, checkout_id: null},
                    reloadOnSearch: false
                })
                .state('gift_card', {
                    url: '/:language/gift_card/:code',
                    templateUrl: 'pages/gift_card/view.gift_card.html',
                    controller: 'GiftCardController',
                    controllerAs: 'vm',
                    params: {language: language_from_cookie, code: null},
                    reloadOnSearch: false
                })
                .state('receipt', {
                    url: '/:language/receipt/:receipt_number',
                    templateUrl: 'pages/receipt/view.receipt.html',
                    controller: 'ReceiptController',
                    controllerAs: 'vm',
                    /* resolve: {
                        authResolve: authResolve
                    }, */
                    params: {language: language_from_cookie, receipt_number: null},
                    reloadOnSearch: false
                })
                .state('create_booking', {
                    url: '/:language/create/booking/:band_slug',
                    templateUrl: 'pages/create_edit_booking/view.create_edit_booking.html',
                    controller: 'CreateEditBookingController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve,
                        countries: function ($http) {
                            return $http.get('/pages/sign_up/countries-' + language_from_cookie + '.json')
                                .then(function (response) {
                                    return response.data;
                                });
                        }
                    },
                    params: {
                        language: language_from_cookie,
                        band_slug: null,
                        backToStateName: '',
                        backToStateParams: {},
                        band_booking_token: null
                    },
                    reloadOnSearch: false
                })
                .state('edit_booking', {
                    url: '/:language/edit/booking/:band_booking_token',
                    templateUrl: 'pages/create_edit_booking/view.create_edit_booking.html',
                    controller: 'CreateEditBookingController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve,
                        countries: function ($http) {
                            return $http.get('/pages/sign_up/countries-' + language_from_cookie + '.json')
                                .then(function (response) {
                                    return response.data;
                                });
                        }
                    },
                    params: {
                        language: language_from_cookie,
                        backToStateName: '',
                        backToStateParams: {},
                        band_booking_token: null
                    },
                    reloadOnSearch: false
                })
                .state('confirm_booking', {
                    url: '/:language/booking/confirm/:band_booking_token',
                    templateUrl: 'pages/confirm_booking/view.confirm_booking.html',
                    controller: 'ConfirmBookingController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve
                    },
                    params: {language: language_from_cookie, band_booking_token: null},
                    reloadOnSearch: false
                })
                .state('booking_contract', {
                    url: '/:language/booking/contract/:band_booking_token',
                    templateUrl: 'pages/confirm_booking/view.confirm_booking.html',
                    controller: 'ConfirmBookingController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve
                    },
                    params: {language: language_from_cookie, band_booking_token: null, show_contract: true},
                    reloadOnSearch: false
                })
                .state('concert_contract', {
                    url: '/:language/concert/contract/:concert_slug',
                    templateUrl: 'pages/concert_contract/view.concert_contract.html',
                    controller: 'ConcertContractController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve
                    },
                    params: {language: language_from_cookie, concert_slug: null},
                    reloadOnSearch: false
                })
                .state('create_musician', {
                    url: '/:language/create/musician',
                    templateUrl: 'pages/create_edit_musician/view.create_edit_musician.html',
                    controller: 'CreateEditMusicianController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve,
                        countries: function ($http) {
                            return $http.get('/pages/sign_up/countries-' + language_from_cookie + '.json')
                                .then(function (response) {
                                    return response.data;
                                });
                        }
                    },
                    params: {language: language_from_cookie, return_page: null, return_params: null},
                    reloadOnSearch: false
                })
                .state('edit_musician', {
                    url: '/:language/edit/musician/:band_slug',
                    templateUrl: 'pages/create_edit_musician/view.create_edit_musician.html',
                    controller: 'CreateEditMusicianController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve,
                        countries: function ($http) {
                            return $http.get('/pages/sign_up/countries-' + language_from_cookie + '.json')
                                .then(function (response) {
                                    return response.data;
                                });
                        }
                    },
                    params: {language: language_from_cookie, return_page: null, return_params: null},
                    reloadOnSearch: false
                })
                .state('create_space', {
                    url: '/:language/create/host',
                    templateUrl: 'pages/create_edit_space/view.create_edit_space.html',
                    controller: 'CreateEditSpaceController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve,
                        countries: function ($http) {
                            return $http.get('/pages/sign_up/countries-' + language_from_cookie + '.json')
                                .then(function (response) {
                                    return response.data;
                                });
                        }
                    },
                    params: {language: language_from_cookie, return_page: null, return_params: null},
                    reloadOnSearch: false
                })
                .state('edit_space', {
                    url: '/:language/edit/host/:space_slug',
                    templateUrl: 'pages/create_edit_space/view.create_edit_space.html',
                    controller: 'CreateEditSpaceController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve,
                        countries: function ($http) {
                            return $http.get('/pages/sign_up/countries-' + language_from_cookie + '.json')
                                .then(function (response) {
                                    return response.data;
                                });
                        }
                    },
                    params: {language: language_from_cookie, return_page: null, return_params: null},
                    reloadOnSearch: false
                })
                .state('band_preview', {
                    url: '/:language/musician/:band_slug/preview',
                    templateUrl: 'pages/musician/view.musician.html',
                    controller: 'MusicianController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve,
                    },
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('space_preview', {
                    url: '/:language/host/:space_slug/preview',
                    templateUrl: 'pages/host/view.host.html',
                    controller: 'HostController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve,
                    },
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('concert_preview', {
                    url: '/:language/concert/:concert_slug/preview',
                    templateUrl: 'pages/concert/view.concert.html',
                    controller: 'ConcertController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve,
                    },
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('followers', {
                    url: '/:language/followers/:profile_type/:profile_slug',
                    templateUrl: 'pages/followers/view.followers.html',
                    controller: 'FollowersController',
                    controllerAs: 'vm',
                    params: {
                        language: language_from_cookie,
                        profile_type: {value: null, dynamic: true},
                        profile_slug: {value: null, dynamic: true},
                        followers: {value: null, dynamic: true}
                    },
                    reloadOnSearch: false
                })
                .state('conversation', {
                    url: '/:language/conversation/:conversation/:recipient?/:affiliate?',
                    templateUrl: 'pages/conversation/view.conversation.html',
                    controller: 'ConversationController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve
                    },
                    params: {
                        language: language_from_cookie,
                        conversation: {value: null, dynamic: true},
                        recipient: {value: null, dynamic: true},
                        affiliate: {value: null, dynamic: true},
                        return_page: null,
                        return_slug: null
                    },
                    reloadOnSearch: false
                })
                .state('review', {
                    url: '/:language/review/:concert_slug',
                    templateUrl: 'pages/review/view.review.html',
                    controller: 'ReviewController',
                    controllerAs: 'review',
                    resolve: {
                        authResolve: authResolve,
                    },
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('promo', {
                    url: '/:language/concert/:concert_slug/promo',
                    templateUrl: 'pages/promo/view.promo.html',
                    controller: 'PromoController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve,
                    },
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('tour_promo', {
                    url: '/:language/tour/:tour_id/promo',
                    templateUrl: 'pages/tour_promo/view.tour_promo.html',
                    controller: 'TourPromoController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve,
                    },
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('stripe_connect', {
                    url: '/:language/payment_info/:mode',
                    templateUrl: 'pages/add_payment_info/view.add_payment_info.html',
                    controller: 'AddPaymentInfoController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve
                    },
                    params: {language: language_from_cookie, mode: 'create'},
                    reloadOnSearch: false
                })
                .state('admin', {
                    url: '/:language/admin/:page?/:pane?/:subPane?/:countryFilter?/:voucherFilter?',
                    templateUrl: 'pages/admin/view.admin.html',
                    controller: 'AdminController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve
                    },
                    params: {
                        language: language_from_cookie,
                        page: 'hosts',
                        pane: 'profiles',
                        subPane: '',
                        countryFilter: 'all',
                        voucherFilter: 'active'
                    },
                    reloadOnSearch: false
                })
                .state('internal_stats', {
                    url: '/:language/internal_stats/:pane',
                    templateUrl: 'pages/internal_stats/view.internal_stats.html',
                    controller: 'InternalStatsController',
                    controllerAs: 'vm',
                    resolve: {
                        authResolve: authResolve,
                    },
                    params: {language: language_from_cookie, pane: 'concerts'},
                    reloadOnSearch: false
                })
                .state('about', {
                    url: '/:language/about',
                    controller: 'AboutController',
                    controllerAs: 'vm',
                    templateUrl: 'pages/about/view.about.html',
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('landing_page', {
                    url: '/:language/live_music/:city',
                    controller: 'LandingPageController',
                    controllerAs: 'vm',
                    templateUrl: 'pages/landing_page/view.landing_page.html',
                    params: {language: language_from_cookie, city: ""},
                    reloadOnSearch: false
                })
                .state('privacy_policy', {
                    url: '/:language/privacy-policy',
                    controller: 'PrivacyController',
                    controllerAs: 'PrivacyCtrl',
                    templateUrl: 'pages/privacy_policy/view.privacy_policy.html',
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('item_deleted', {
                    url: '/:language/item-deleted',
                    controller: 'ItemDeletedController',
                    controllerAs: 'DeletedCTRL',
                    templateUrl: 'pages/item_deleted/view.item_deleted.html',
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('terms_of_use', {
                    url: '/:language/terms-of-use',
                    controller: 'TermsController',
                    controllerAs: 'TermsCtrl',
                    templateUrl: 'pages/terms_of_use/view.terms_of_use.html',
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('booking', {
                    url: '/:language/booking',
                    controller: 'BookingController',
                    controllerAs: 'BookingCtrl',
                    templateUrl: 'pages/booking/view.booking.html',
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('guide_for_concert_goers', {
                    url: '/:language/guide-for-concert-goers',
                    controller: 'GuideForConcertGoersController',
                    controllerAs: 'GuideForConcertGoersCtrl',
                    templateUrl: 'pages/guide_for_concert_goers/view.guide_for_concert_goers.html',
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('guide_for_outdoor_concerts', {
                    url: '/:language/guide-for-outdoor-concerts',
                    controller: 'GuideForOutdoorConcertsController',
                    controllerAs: 'GuideForOutdoorConcertsCtrl',
                    templateUrl: 'pages/guide_for_outdoor_concerts/view.guide_for_outdoor_concerts.html',
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('guide_hosts', {
                    url: '/:language/host-guide',
                    controller: 'GuideHostsController',
                    controllerAs: 'GuideHostsCtrl',
                    templateUrl: 'pages/guide_hosts/view.guide_hosts.html',
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('guide_musicians', {
                    url: '/:language/musician-guide',
                    controller: 'GuideMusiciansController',
                    controllerAs: 'GuideMusiciansCtrl',
                    templateUrl: 'pages/guide_musicians/view.guide_musicians.html',
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('blog', {
                    url: '/:language/blog',
                    controller: 'BlogController',
                    controllerAs: 'vm',
                    templateUrl: 'pages/blog/view.blog.html',
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('identity_verification', {
                    url: '/:language/identity_verification',
                    controller: 'IdentityVerificationController',
                    controllerAs: 'vm',
                    templateUrl: 'pages/identity_verification/view.identity_verification.html',
                    params: {language: language_from_cookie},
                    reloadOnSearch: false
                })
                .state('forgotten_password', {
                    url: '/:language/forgot',
                    templateUrl: 'pages/forgotten_password/view.forgotten_password.html',
                    controller: 'ForgottenPasswordController',
                    controllerAs: 'vm',
                    params: {
                        user_email: '',
                        language: language_from_cookie
                    },
                    reloadOnSearch: false
                })
                .state('reset_password', {
                    url: '/:language/reset_password?t&email&password_changed',
                    templateUrl: 'pages/reset_password/view.reset_password.html',
                    controller: 'ResetPasswordController',
                    controllerAs: 'vm',
                    params: {language: language_from_cookie},
                    resolve: {
                        isTokenValid: function ($http, $stateParams) {
                            return $http.post("app/api/users/reset_password/validate", {
                                token: $stateParams.t
                            }).then(function (response) {
                                return response.data;
                            });
                        }
                    },
                    reloadOnSearch: false
                });
        });

    function authResolve(authenticator, $state, $timeout) {
        return authenticator.checkLoginStatus()
            .then(function (loggedIn) {
                if (!loggedIn) {
                    $timeout(function () {
                        $state.transitionTo(
                            'login',
                            {'backToStateName': $state.toName, 'backToStateParams': $state.toParams},
                            {
                                location: true, inherit: true,
                                relative: $state.$current,
                                notify: false
                            }
                        );
                    });
                }
            });
    }
})();
